import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Truck, LogOut } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { getMyActiveDeliveries } from '../../../services/orderService';
import LocationBroadcaster from '../../../components/driver/LocationBroadcaster';

const DriverLayout: React.FC = () => {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    const [jobs, setJobs] = useState<any[]>([]);

    // We need to fetch jobs here to power the Beacon even if on JobDetails page
    // This simple polling ensures Broadcaster knows about active jobs
    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const data = await getMyActiveDeliveries();
                setJobs(data);
            } catch (err) {
                console.error('Beacon failed to check jobs', err);
            }
        };

        fetchJobs();
        const interval = setInterval(fetchJobs, 30000); // Check every 30s
        return () => clearInterval(interval);
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col">
            {/* The Beacon */}
            <LocationBroadcaster activeJobs={jobs} />

            {/* Protocol B: Mobile First Header */}
            <header className="bg-white border-b border-gray-200 px-4 py-3 flex justify-between items-center sticky top-0 z-50">
                <div className="flex items-center gap-2">
                    <div className="bg-blue-600 p-1.5 rounded-lg">
                        <Truck className="w-5 h-5 text-white" />
                    </div>
                    <span className="font-bold text-gray-900 tracking-tight">GFF Logistics</span>
                </div>

                <button
                    onClick={handleLogout}
                    className="p-2 text-gray-500 hover:bg-gray-50 rounded-full transition-colors"
                >
                    <LogOut className="w-5 h-5" />
                </button>
            </header>

            {/* Content Container - max-w-md for mobile simulation on desktop */}
            <main className="flex-1 w-full max-w-md mx-auto p-4 safe-area-bottom">
                <Outlet />
            </main>
        </div>
    );
};

export default DriverLayout;
